import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView, View } from "@frui.ts/views";
import { Observer, observer } from "mobx-react-lite";
import InventoryViewModel from "viewModels/finance/accountingInventory/inventoryViewModel";

const CustomerRefundsView: ViewComponent<InventoryViewModel> = observer(({ vm }) => {
  return <Observer>{() => <View vm={vm.activeChild} />}</Observer>;
});

registerView(CustomerRefundsView, InventoryViewModel);
